// Purpose: translate untrusted callback markers into categorical, non-sensitive UI text.
const messages: Record<string, string> = {
  provider_error: 'Sign-in was cancelled or refused by the provider. Please try again.',
  unverified_email: 'The provider did not verify your email. Verify it with the provider before signing in.',
  account_already_exists: 'This sign-in method is not linked to your Console account. Use your previously linked provider or contact your administrator. Accounts are not linked automatically.',
  link_failed: 'Console could not complete identity linking. Please contact your administrator.',
  invalid_state: 'This sign-in attempt expired or was already used. Please start again.',
  identity_verification_failed: 'Console could not verify the provider identity. Please try again or contact your administrator.',
  provider_unavailable: 'This sign-in provider is unavailable. Please contact your administrator.',
};

export function callbackMessage(search: string): string | null {
  const params = new URLSearchParams(search);
  if (params.has('auth_error')) {
    const category = params.get('auth_error') ?? '';
    return Object.hasOwn(messages, category) ? messages[category] : 'Console sign-in failed. Please try again or contact your administrator.';
  }
  if (params.get('auth') === 'success') return 'Sign-in returned, but Console could not restore a session. Please try again or contact your administrator. No account or membership changes were made by this check.';
  return null;
}

export function clearCallbackParameters(): void {
  const url = new URL(window.location.href);
  for (const key of ['auth', 'auth_error', 'provider', 'code', 'state', 'error', 'error_description']) url.searchParams.delete(key);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
